import React, { FC } from 'react';
import { Tooltip } from '@beeline.com/bp-design-system';
import styled from 'styled-components';
import { PermissionAction } from '@utmost.co/enterprise-models';
import { useSmartformPermissionHelper } from 'src/components/smartforms/useSmartformPermissionHelper';

interface Props {
  canRead: boolean;
  permissions: {
    name: string;
    action: PermissionAction;
  }[];
}

export const DeniedPermissionHelper: FC<React.PropsWithChildren<Props>> = ({ children, canRead, permissions }) => {
  const { helperEnabled } = useSmartformPermissionHelper();
  if (canRead) return <>{children}</>;
  if (!canRead && !helperEnabled) return null;

  return (
    <Tooltip title={permissions?.map((permission) => `${permission.name} ${permission.action} DENIED`).join(', ')}>
      <StyledNoRead>
        <StyledNoReadContent>{children}</StyledNoReadContent>
      </StyledNoRead>
    </Tooltip>
  );
};

const StyledNoRead = styled.span`
  opacity: 0.3;
`;

const StyledNoReadContent = styled.span`
  pointer-events: none;
`;
